import { useMemo } from "react";

import { REQUESTOR_ROLE_CODE } from "../constants";

type RoleLike = { id: string; code?: string | null };

export function useRequestorRoleMeta<R extends RoleLike>({
  roles,
  enableRequestorRole,
  initialRoleId,
}: {
  roles: R[] | undefined;
  enableRequestorRole: boolean;
  initialRoleId?: string;
}): { requestorRoleId: string | undefined; visibleRoles: R[] | undefined } {
  const requestorRoleId = useMemo(
    () => roles?.find((r) => r.code === REQUESTOR_ROLE_CODE)?.id,
    [roles]
  );

  const visibleRoles = useMemo(() => {
    if (!roles) return undefined;
    if (enableRequestorRole || !requestorRoleId) return roles;
    return roles.filter(
      (r) => r.id !== requestorRoleId || r.id === initialRoleId
    );
  }, [roles, requestorRoleId, enableRequestorRole, initialRoleId]);

  return { requestorRoleId, visibleRoles };
}
